var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.tabGroup},_vm._l((_vm.allTabs),function(tab){return _c('Tab',{key:tab.id,attrs:{"id":tab.id,"path":tab.path,"title":tab.title,"isCloseable":tab.isCloseable}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }